import React from "react";
import SEOLandingPage from "../../../components/tools/SEOLandingPage";

const AINoteTaking: React.FC = () => {
  return (
    <SEOLandingPage
      // SEO
      title="AI Note Taking App for Students - Smart Notes | YouWo AI"
      metaDescription="The smartest note taking app for students. AI transcribes lectures, summarizes content, and creates study materials automatically. Free AI-powered notes."
      keywords="ai note taking, smart notes app, ai notes app, student note app, automatic note taking, lecture notes app, ai study notes"
      canonicalUrl="https://youwo.ai/tools/ai-note-taking"
      // Hero
      headline="AI Note Taking: Focus on Learning, Not Writing"
      subheadline="Stop scrambling to write everything down. YouWo AI's AI takes comprehensive notes for you so you can focus on understanding the material."
      heroIcon="lucide:notebook"
      heroIconColor="text-emerald-500"
      heroIconBg="bg-emerald-50"
      // Problem/Solution
      problemTitle="Traditional Note Taking Holds You Back"
      problemDescription="When you're busy writing, you can't fully engage with the lecture. You miss important context while transcribing words. Then you have messy notes that are hard to study from."
      solutionTitle="AI That Understands and Organizes"
      solutionDescription="Our AI captures everything and organizes it intelligently. It identifies main topics, key concepts, and supporting details - creating notes that are actually useful for studying."
      // Features
      features={[
        {
          icon: "lucide:globe",
          title: "100+ Languages",
          description: "Take notes in over 100 languages with automatic detection.",
        },
        {
          icon: "lucide:clock",
          title: "Clickable Timestamps",
          description: "Jump to any moment in recordings with clickable timestamps.",
        },
        {
          icon: "lucide:mic",
          title: "Live Transcription",
          description: "Record lectures and get real-time transcription with 99% accuracy.",
        },
        {
          icon: "lucide:highlighter",
          title: "Key Point Detection",
          description: "AI highlights important concepts, definitions, and exam-worthy content.",
        },
        {
          icon: "lucide:layers",
          title: "Active Recall Flashcards",
          description: "Turn notes into flashcards using active recall learning.",
        },
        {
          icon: "lucide:search",
          title: "Semantic Search",
          description: "Find anything across all your notes with natural language search.",
        },
      ]}
      // CTA
      ctaText="Try AI Notes Free"
      ctaLink="https://apps.apple.com/app/youwo-ai-agent/id6760689478"
      // Related
      relatedTools={[
        { name: "Lecture Notes AI", href: "/tools/lecture-notes", icon: "lucide:graduation-cap" },
        { name: "Notability Alternative", href: "/tools/notability-alternative", icon: "lucide:edit-3" },
        { name: "Audio Transcriber", href: "/tools/audio-transcriber", icon: "lucide:mic" },
        { name: "PDF Summarizer", href: "/tools/pdf-summarizer", icon: "lucide:file-text" },
      ]}
    />
  );
};

export default AINoteTaking;
